import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_contact_import_file_hdr_RowInterface {
   guid: fromDatatype.GuidDataFieldInterface;
   file_guid: fromDatatype.GuidDataFieldInterface;
   applet_guid: fromDatatype.GuidDataFieldInterface;
   module_guid: fromDatatype.GuidDataFieldInterface;
   file_name: fromDatatype.VarcharDatatypeInterface;
   file_size: fromDatatype.NumericDatatypeInterface;
   import_format: fromDatatype.VarcharDatatypeInterface;
   type: fromDatatype.VarcharDatatypeInterface;
   process_status: fromDatatype.VarcharDatatypeInterface;
   error_message: fromDatatype.TextDatatypeInterface;
   property_json: fromDatatype.JsonDatatypeInterface;
   acl_config: fromDatatype.JsonDatatypeInterface;
   acl_policy: fromDatatype.JsonDatatypeInterface;
   created_date: fromDatatype.TimestampTzDatatypeInterface;
   updated_date: fromDatatype.TimestampTzDatatypeInterface;
   created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
   updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
   status: fromDatatype.VarcharDatatypeClass;
   revision: fromDatatype.RevisionDataFieldInterface;
   vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_crm_contact_import_file_hdr_RowClass
   implements bl_crm_contact_import_file_hdr_RowInterface{
   guid: fromDatatype.GuidDataFieldInterface;
   file_guid: fromDatatype.GuidDataFieldInterface;
   applet_guid: fromDatatype.GuidDataFieldInterface;
   module_guid: fromDatatype.GuidDataFieldInterface;
   file_name: fromDatatype.VarcharDatatypeInterface;
   file_size: fromDatatype.NumericDatatypeInterface;
   import_format: fromDatatype.VarcharDatatypeInterface;
   type: fromDatatype.VarcharDatatypeInterface;
   process_status: fromDatatype.VarcharDatatypeInterface;
   error_message: fromDatatype.TextDatatypeInterface;
   property_json: fromDatatype.JsonDatatypeInterface;
   acl_config: fromDatatype.JsonDatatypeInterface;
   acl_policy: fromDatatype.JsonDatatypeInterface;
   created_date: fromDatatype.TimestampTzDatatypeInterface;
   updated_date: fromDatatype.TimestampTzDatatypeInterface;
   created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
   updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
   status: fromDatatype.VarcharDatatypeClass;
   revision: fromDatatype.RevisionDataFieldInterface;
   vrsn: fromDatatype.VrsnDataFieldInterface;
}
